import Dexie from "dexie";

const db = new Dexie("DigitAirInflight");

db.version(1).stores({
  products:   "_id, category, isActive, productCode",
  sessions:   "_id, syncStatus, crewCode",
  flightCrew: "flightKey",
  orders:     "clientId, sessionId, syncStatus, deviceTimestamp",
  syncLog:    "++id, attemptedAt, status",
});

export default db;
